<template>
  <v-app>
    <v-content>
      <v-app-bar
        flat
        height="127"
      >
        <v-container>
          <v-row no-gutters align="center">
            <v-col>
              <v-img
                alt="Logo"
                :src="require('@/assets/logo.png')"
                width="120"
              />
            </v-col>
            <v-spacer></v-spacer>
            <v-btn text href="#about">{{ $t('toolbar.about') }}</v-btn>
            <v-btn text href="#services">{{ $t('toolbar.services') }}</v-btn>
            <v-btn text href="#experience">{{ $t('toolbar.experience') }}</v-btn>
            <v-btn text href="#geo">{{ $t('toolbar.geo') }}</v-btn>
            <v-btn text href="#contacts">{{ $t('toolbar.contacts') }}</v-btn>
            <v-btn
              text
              style="min-width: auto; padding: 0 5px"
              @click="$i18n.locale = 'ua'"
              :disabled="$i18n.locale === 'ua'"
            >
              UA
            </v-btn>
            <v-btn
              text
              style="min-width: auto; padding: 0 5px"
              @click="$i18n.locale = 'en'"
              :disabled="$i18n.locale === 'en'"
            >
              EN
            </v-btn>

          </v-row>
        </v-container>
      </v-app-bar>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    name: 'App',

    components: {},
    data: () => ({
      //
    })
  }
</script>

<style>
  .page-section {
    background: linear-gradient(#f9f9f9, #eaeaea);
  }
</style>
